module.exports = __webpack_public_path__ + "static/media/sky.64d20750.png";